export default __webpack_public_path__ + "static/media/814.a85ec808.gif";